import { LinkOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { Trans } from 'react-i18next';
import { Link, Outlet, useMatch } from 'react-router-dom';

import useAPIQuery from '../api/useAPIQuery';
import Config from '../app/config';
import ErrorResult from '../components/ErrorResult';
import Header from '../components/Header';
import SankhyaSideMenu from '../components/SankhyaSideMenu';
import { useEnableSankhyaMenu } from '../hooks/useEnableSankhyaMenu';
import usePermissionCheckerQuery from '../hooks/usePermissionCheckerQuery';
import useTypedParams from '../hooks/useTypedParams';
import styles from './DashboardNavigator.module.css';

const DashboardNavigator = () => {
  const match = useMatch(':tenant/:menu/*');
  const config = useAPIQuery('/configs/tenant-configurations/');
  const { tenant } = useTypedParams({ tenant: String });

  const user = useAPIQuery('/users/me/');

  const talentPoolPermissionChecker = usePermissionCheckerQuery(['access_talent_pool']);
  const accessReportsPermissionChecker = usePermissionCheckerQuery([
    'view_all_vacancies',
    'access_reports',
  ]);
  const configurationsPermissionChecker = usePermissionCheckerQuery(['access_configurations']);
  const requestJobPostingPermissionChecker = usePermissionCheckerQuery(
    ['view_all_request_job_postings', 'view_marked_request_job_postings'],
    'or'
  );

  const { enableSankhyaMenu } = useEnableSankhyaMenu(Config.REACT_APP_AUTH_DOMAIN || '');

  return (
    <ErrorResult error={config.error}>
      {config.data?.enableSideMenu && enableSankhyaMenu && (
        <SankhyaSideMenu authDomain={Config.REACT_APP_AUTH_DOMAIN} />
      )}
      <Layout
        className={styles.layout}
        style={{
          paddingLeft: config.data?.enableSideMenu && enableSankhyaMenu ? 64 : 0,
        }}
      >
        <Header
          user={user.data}
          enableSideMenu={config.data?.enableSideMenu}
          enableSankhyaMenu={enableSankhyaMenu}
          configurationsPermissionChecker={configurationsPermissionChecker.data}
        />

        <nav className={styles.nav}>
          <Menu
            mode="horizontal"
            className={styles.menu}
            selectedKeys={[match?.params?.menu || '']}
            items={[
              ...(requestJobPostingPermissionChecker.data
                ? [
                    {
                      key: 'request-job-postings',
                      label: (
                        <Link to="request-job-postings">
                          <Trans>Requisições</Trans>
                        </Link>
                      ),
                    },
                  ]
                : []),
              {
                key: 'opportunities',
                label: (
                  <Link to="opportunities">
                    <Trans>Vagas</Trans>
                  </Link>
                ),
              },
              ...(talentPoolPermissionChecker.data
                ? [
                    {
                      key: 'talent-pool',
                      label: (
                        <Link to="talent-pool">
                          <Trans>Banco de talentos</Trans>
                        </Link>
                      ),
                    },
                  ]
                : []),
              ...(accessReportsPermissionChecker.data
                ? [
                    {
                      key: 'reports',
                      label: (
                        <Link to="reports">
                          <Trans>Relatórios</Trans>
                        </Link>
                      ),
                    },
                  ]
                : []),
              {
                key: 'portal',
                label: (
                  <a href={`${Config.REACT_APP_CAREER_PAGE_URL}${tenant}`} target="_blank">
                    <Trans>Página de Carreiras</Trans> <LinkOutlined />
                  </a>
                ),
              },
            ]}
          />
        </nav>
        <Layout.Content>
          <Outlet />
        </Layout.Content>
      </Layout>
    </ErrorResult>
  );
};

export default DashboardNavigator;
